import { useEffect, useRef } from 'react';

import { useAtom } from 'jotai';

import { useSelectedDealer } from '@lotlinx-aws/dealer-selector';
import usePathPattern from 'hooks/usePathPattern';
import ROUTES from 'routes';
import { userAtom } from 'store';
import { ClickContext, initClickTracker, teardownClickTracker } from 'util/clickTracker';

export default function useClickTracker() {
  const { dealer } = useSelectedDealer();
  const [user] = useAtom(userAtom);
  const pattern = usePathPattern(ROUTES);

  const contextRef = useRef<ClickContext>({ page_pattern: '' });

  useEffect(() => {
    contextRef.current = {
      page_pattern: pattern,
      userid: user?.id,
      vm_visitor_id: user?.id,
      vm_visitor_email: user?.email,
      vm_account_dealerid: dealer?.id,
      vm_account_name: dealer?.name,
    };
  }, [pattern, user?.id, user?.email, dealer?.id, dealer?.name]);

  useEffect(() => {
    initClickTracker(() => contextRef.current);
    return teardownClickTracker;
  }, []);
}
